import t from "../../translations";

const yellowQuotation = [
    t('yellow_quotation'),
  ];
  
  export default yellowQuotation;
  